import { ReactElement } from 'react';

import styles from './TipBox.module.css';
import { InformationSVG } from '../../../../../../svgComponents/informationSVG/InformationSVG';

function TipBox({ tip }: { tip: ReactElement }) {
    return (
        <div className={styles.TipBox}>
            <InformationSVG className={styles.TipBoxIcon} />
            <div className={styles.TipBoxCopy}>{tip}</div>
        </div>
    );
}

// eslint-disable-next-line import/no-default-export
export default TipBox;
